import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiInput from './AiInput'

const mapStateToProps = (state, ownProps) => ({
  childrenE: state['options_'+ownProps.attr].options,
  optionE: state['options_'+ownProps.attr],
  sc: state.sc,
  loading:state.loading,
  lsbefore:state['lsbefore']
  

})


 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value}))),
  onReqCharE1: ( () => dispatch(state_update({attr:"reqCharE1",value:"yes"}))),
  onLoadingDone: (() =>{ 
   // console.log('onLoadingDone')
  //  dispatch(state_update({attr:'showSticky',value:true}) )
    dispatch(state_update({attr:'loading',value:'done'}) )
  }
  ),
 
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiInput)


// WEBPACK FOOTER //
// ./src/layout/AiInputWrap.js